import { Form, Modal, Select } from 'antd';

import { mediaTypeOptions } from './helpers';

/**
 * Dosya türü (mediaType) seçimi.
 *
 * @param {Object} props
 * @param {boolean} [props.disabled=false] - true ise tür değiştirilemez (read-only). Düzenleme
 *   modallarında kullanılır: `mediaType` grup düzeyinde sabittir ve BE `/revise`'de kabul etmez,
 *   bu yüzden mevcut bir teklifi düzenlerken tür değiştirilemez; yalnız yeni ekleme akışında editable.
 */
function MediaTypeSection({ disabled = false }) {
  const form = Form.useFormInstance();
  const media = Form.useWatch('media', form);
  const mediaType = Form.useWatch('mediaType', form);

  const handleChange = () => {
    // Yüklü dosya yoksa serbestçe değiştir
    if (!media || media.length === 0) return;

    // Bu render'ın closure'ındaki `mediaType` değişiklikten ÖNCEKI commit edilmiş değerdir
    // (Form.Item store'u güncelledikten sonra onChange çağrılsa da closure değeri sabittir).
    const previousType = mediaType;

    Modal.confirm({
      title: 'Dosya türünü değiştir',
      content: 'Türü değiştirirseniz yüklü dosyalar sıfırlanacaktır. Devam edilsin mi?',
      okText: 'Evet, sıfırla',
      cancelText: 'Vazgeç',
      onOk: () => {
        form.setFieldsValue({ media: [] });
      },
      onCancel: () => {
        // Değişikliği geri al: önceki türe dön
        form.setFieldsValue({ mediaType: previousType });
      },
    });
  };

  return (
    <Form.Item
      label="Dosya Türü"
      name="mediaType"
      required
      rules={[
        {
          required: true,
          message: 'Lütfen dosya türünü seçiniz',
        },
      ]}
    >
      <Select
        placeholder="Seçiniz"
        options={mediaTypeOptions}
        onChange={handleChange}
        disabled={disabled}
      />
    </Form.Item>
  );
}
export default MediaTypeSection;
